import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import { Link } from 'react-router-dom';
import { canUseDOM } from 'exenv';

import Ad from '../ad/ad';
import VideoModule from '../video_module/video_module';
import Author from '../author/author';
import NewsletterSignup from '../newsletter-signup/newsletter-signup';
import Advertorial, { isAdvertorial } from '../advertorial/advertorial';
import HeaderMedia from './header/post_header';
import Sidebar from './sidebar/post_sidebar';
import Social from '../social/social';
import Eyebrow from '../eyebrow/eyebrow';
import Autoplay from './utils/embed_autoplay';
import {
  determineIfMagazine,
  determineMagazineIssueMonth,
  determineMagazineIssueNumber
} from '../../../utils/tag_category_util';
import NotFound from '../not_found_component/not_found_component';
import MagazineAttribution from '../magazine_attribution/magazine_attribution';
import FCLink from '../fc_link/fc_link';
import MoreStories from '../more-stories-component/more-stories-component';
import FCSlider from '../fc_slider/fc_slider';
import RevContent from '../revcontent/revcontent';

export default class Post extends Component {
  constructor() {
    super();

    this.renderPostArticle = this.renderPostArticle.bind(this);
    this.videosOnPage = [];
    this.cachedVideosOnPage = [];
    this.activatedVideosOnPage = [];
    this.mobileAdIndex = 0;
    this.hasAttributionByline = false;
  }

  componentDidMount() {
    this.rendered = true;
  }

  shouldComponentUpdate(nP) {
    const { props, rendered } = this;
    // this.props.config.initialPageLoad is needed for the first post to enable sticky ads.
    const isInitLoad = props.config.initialPageLoad;
    const hasHeightChange = nP.relatedHeight !== props.relatedHeight;

    return !rendered || isInitLoad || hasHeightChange || nP.postFinite.length;
  }

  componentWillUpdate() {
    // Need to reset for rerender.
    this.mobileAdIndex = 0;
  }

  componentDidUpdate() {
    if (canUseDOM) {
      this.videosOnPage = document.querySelectorAll(
        '.inline-video iframe[src*="fastco"]'
      );
      if (this.cachedVideosOnPage.length !== this.videosOnPage.length) {
        this.cachedVideosOnPage = this.videosOnPage;
        for (let i = 0; i < this.activatedVideosOnPage.length; i += 1) {
          this.activatedVideosOnPage[i].off();
        }
        for (let i = 0; i < this.videosOnPage.length; i += 1) {
          const activeVid = new Autoplay(this.videosOnPage[i]);
          activeVid.on();
          this.activatedVideosOnPage.push(activeVid);
        }
      }
    }
  }

  componentWillUnmount() {
    for (let i = 0; i < this.activatedVideosOnPage.length; i += 1) {
      this.activatedVideosOnPage[i].off();
    }
  }

  setPostWrapperClasses(advertorial) {
    const classNames = ['post__wrapper'];

    if (advertorial) {
      classNames.push('post__wrapper--advertorial');
    }

    return classNames.join(' ');
  }

  setMobileAdName(index) {
    let adName;
    const adMap = { 0: 'mobileparallax_1', 3: 'mobileparallax_2' };

    if (Object.prototype.hasOwnProperty.call(adMap, index)) {
      adName = adMap[index];
    } else {
      adName = `mobilerectangle_${(this.mobileAdIndex += 1)}`;
    }

    return adName;
  }

  setPostChunk(chunk) {
    const markup = chunk.join('');

    if (markup === 'INLINE_CAROUSEL') {
      return (
        <FCSlider
          slideShowData={this.inlineCarousels.shift()}
          location="post__inline"
        />
      );
    }

    return <div dangerouslySetInnerHTML={{ __html: markup }} />;
  }

  renderPostArticle(chunks, combinedAdModel) {
    if (!chunks.length) {
      return null;
    }

    return (
      <article className="post__article">
        {chunks.map((chunk, index) => [
          this.setPostChunk(chunk),
          index < chunks.length - 1
            ? <Ad
                {...combinedAdModel}
                pos="btf"
                pageNum={get(this.props, 'pageNum')}
                name={this.setMobileAdName(index)}
              />
            : ''
        ])}
      </article>
    );
  }

  renderAuthorLink(tags, author) {
    let bylineAttribution = null;

    forEach(tags, tag => {
      if (
        tag.name.indexOf('byline_') !== -1 ||
        tag.slug.indexOf('byline-') !== -1
      ) {
        bylineAttribution = tag.name.replace('byline_', '');
        this.hasAttributionByline = true;
      }
    });

    if (bylineAttribution) {
      return (
        <span className="post__by-link-no-underline">
          By {bylineAttribution}
        </span>
      );
    }

    return (
      <Link className="post__by-link" to={`/user/${author.slug}`}>
        By {author.name}
      </Link>
    );
  }

  renderKiaAdWords(kia) {
    if (kia) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html:
              '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }}
        />
      );
    }

    return null;
  }

  renderPost(post, advertorial, related, combinedAdModel, postExtras, config) {
    const tags = post.tags;
    const categories = post.categories;
    const author = post.author;
    const featuredImage = post.featured_image;
    const article = post.content;
    const classNames = this.props.modifier
      ? `post post--${this.props.modifier}`
      : 'post';
    const slideShowData = post.posterSlideshow;
    const videoData = post.posterVideo;
    const videoAdData = this.props.postpage
      ? get(this.props, 'postpage.ads.model')
      : null;
    const iframeData = post.posterIframe;
    const emptyContent = !article.length;
    const currentSite = get(this.props, 'config.site');
    const authorAttribution = this.renderAuthorLink(tags, author);
    const isKia = tags.filter(tag => tag.slug === 'kia_niro').length;

    this.inlineCarousels = cloneDeep(get(post, 'inlineCarousels')) || [];

    return (
      <section className={classNames}>
        <div
          className={`post__main ${!postExtras
            ? 'post__main--article-rule'
            : ''}`}
        >
          <header className="post__header">
            {advertorial
              ? <Advertorial tags={tags} adModel={combinedAdModel} />
              : ''}

            <Eyebrow post={post} tags={tags} />

            <FCLink
              currentSite={currentSite}
              externalLink={!postExtras}
              to={post.link}
              title={post.title}
            >
              {postExtras
                ? <h1 className="post__title">{post.title}</h1>
                : <h2 className="post__title">{post.title}</h2>}
            </FCLink>

            <h2
              className="post__deck"
              dangerouslySetInnerHTML={{ __html: post.excerpt }}
            />

            <HeaderMedia
              posterImg={featuredImage}
              slideShowData={slideShowData}
              videoData={videoData}
              videoAdData={videoAdData}
              iframeData={iframeData}
              title={post.title}
            />
          </header>

          <div className="post__container">
            <Social
              enableSticky={this.props.isDesktop}
              empty={emptyContent}
              text={encodeURIComponent(get(post, 'title') || '')}
              uri={post.link}
              modifier="post"
              bottomBoundary={`#social--${post.id}`}
              encapsulateId={`social--${post.id}`}
            />
            <div className="post__content">
              <div className="post__byline">
                <cite className="post__by">
                  {authorAttribution}
                </cite>
                <span className="post__readTime">
                  {get(post, 'readTime')} Read
                </span>
              </div>
              {this.renderPostArticle(article, combinedAdModel)}
              <footer className="post__footer">
                {determineIfMagazine(categories)
                  ? <MagazineAttribution
                      issueMonth={determineMagazineIssueMonth(tags)}
                      issueNumber={determineMagazineIssueNumber(tags)}
                      currentSite={currentSite}
                      env={config.env}
                    />
                  : ''}
                {!this.hasAttributionByline
                  ? <Author modifier="post" {...author} />
                  : ''}
                <NewsletterSignup
                  modifier="post"
                  primary={currentSite}
                  newsletters={[
                    { list: currentSite, default: true },
                    { list: 'events', default: true }
                  ]}
                />
              </footer>
              {this.renderKiaAdWords(isKia)}
            </div>
          </div>
        </div>
        <Sidebar
          post={post}
          related={related}
          postExtras={postExtras}
          combinedAdModel={combinedAdModel}
          isDesktop={this.props.isDesktop}
          site={get(this.props, 'config.site')}
          pageNum={get(this.props, 'pageNum')}
          relatedHeight={this.props.relatedHeight}
          fullPageAdvertorial={advertorial}
        />
      </section>
    );
  }

  renderRevContentOrMoreStories() {
    const { config, postAfterbodyRecircModuleType } = this.props;
    const moduleType = get(postAfterbodyRecircModuleType, 'type');

    if (this.props.postExtras) {
      if (moduleType === 'More Stories') {
        return this.renderMoreStories();
      }

      return (
        <RevContent
          initialPageLoad={get(config, 'initialPageLoad')}
          site={get(config, 'site')}
        />
      );
    }

    return null;
  }

  renderVideo() {
    const { postVideo } = this.props;

    if (this.props.postExtras && !isEmpty(postVideo)) {
      const currentSite = get(this.props, 'config.site');

      return (
        <VideoModule
          data={postVideo}
          playerid="MyQ2uJQ0"
          stories={this.props.postVideo.playlist}
          currentSite={currentSite}
          isPost={true}
        />
      );
    }

    return null;
  }

  renderMoreStories() {
    const postMoreStories = get(this.props, 'postMoreStories.posts');

    if (
      this.props.postExtras &&
      postMoreStories &&
      postMoreStories.length &&
      this.props.postFinite.length
    ) {
      const currentSite = get(this.props, 'config.site');
      return (
        <MoreStories
          metadata={postMoreStories}
          isPost={true}
          currentSite={currentSite}
        />
      );
    }

    return null;
  }

  render() {
    const { post, related, postExtras, config, pageNum } = this.props;
    const tags = get(post, 'tags');
    const advertorial = isAdvertorial(tags);
    const combinedAdModel = this.props.combinedAdModel || {};
    // First ad = flexiblepushdown, the rest from inf scroll = flexiblebillboard
    const adName = postExtras ? 'flexiblepushdown' : 'flexiblebillboard';

    if (!isEmpty(post)) {
      return (
        <div>
          <div
            className={this.setPostWrapperClasses(advertorial)}
            data-id={post.id}
          >
            <div className="post__article-top-ad-wrapper">
              <Ad
                {...combinedAdModel}
                name={adName}
                region="articletop"
                pageNum={pageNum}
              />
              <Ad
                {...combinedAdModel}
                name="mobileleaderboard"
                region="articletop"
                pageNum={pageNum}
              />
              <Ad
                {...combinedAdModel}
                name="oop"
                slug="false"
                oop="true"
                pageNum={pageNum}
              />
            </div>
            {this.renderPost(
              post,
              advertorial,
              related,
              combinedAdModel,
              postExtras,
              config
            )}
          </div>

          {this.renderRevContentOrMoreStories()}
          {this.renderVideo()}
        </div>
      );
    }
    return (
      <NotFound
        statusCode={this.props.statusCode}
        message={this.props.statusCode === 403 ? 'Post is not available.' : ''}
      />
    );
  }
}

Post.defaultProps = {
  isDesktop: false,
  postExtras: false,
  modifier: '',
  relatedHeight: 0,
  postVideo: {},
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  }
};

Post.propTypes = {
  statusCode: PropTypes.number.isRequired,
  config: PropTypes.shape({
    initialPageLoad: PropTypes.bool
  }).isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postpage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  postVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  }),
  postFinite: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postAfterbodyRecircModuleType: PropTypes.shape({
    type: PropTypes.string
  }),
  isDesktop: PropTypes.bool,
  postExtras: PropTypes.bool,
  pageNum: PropTypes.number.isRequired,
  modifier: PropTypes.string,
  relatedHeight: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/views/components/post/post.js